import InputTypesEnum from '../../Enums/InputTypesEnum';
import SearchParamsBase from '../../Elements/SearchParamsBase';

export default class FteTrackingSearchParams extends SearchParamsBase {
  initialize() {
    const now = new Date();
    this.Year = now.getFullYear();
    this.Month = now.getMonth() + 1;
    this.FieldworkOfficeId = '';
    this.Statuses = [];
  }

  static fieldsInSearchBox = [
    { fieldName: 'FieldworkOfficeId', label: 'Office', className: 'col-3', type: InputTypesEnum.OfficeOrGroupSelect },
    {
      fieldName: 'Statuses',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.MultiChoice,
      options: FteTrackingSearchParams.getStatusOptions(),
    },
  ];

  static getStatusOptions() {
    return [
      { label: 'Open', value: 'Open' },
      { label: 'Locked', value: 'Locked' },
      { label: 'Confirmed', value: 'Confirmed' },
      { label: 'Invoiced', value: 'Invoiced' },
    ];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'FteTrackingSearchParams';
}
